



























import { Vue, Component, Prop } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';

@Component({
  components: {
    CabeceraModal,
  },
})
export default class CabeceraModalDevolucionEditar extends Vue {
  @Prop({ default: false }) mostrarBtnVolver: Boolean;
  @Prop({ default: false }) permitirContinuarEditar: Boolean;
  @Prop({ default: true }) mostrarBtnContinuarEditar: Boolean;

  cont() {
    this.$emit(
      'continuarEditar',
      this.permitirContinuarEditar ? 'edit' : 'no-edit'
    );
  }
  volv() {
    this.$emit('volverEditar');
  }
}
